<template>
	<ul :class="{[className]: true}">
		<li
			v-for="item in filteredMenu"
			:key="item.to"
		>
			<a v-if="isOnePage"
				href="#"
				@click="sendEventGA('Page', item.name)"
				v-scroll-to="{
					el: `.section--${item.to}`,
					offset: widgets.scrollOffset,
					onStart: onScrollingStart,
					onDone: onScrollingDone
				}"
			>
				{{ item.name }}
			</a>
			<router-link v-else :to="routeUrl(item.to)" v-on:click.native="sendEventGA('Page', item.name)">{{ item.name }}</router-link>
		</li>
	</ul>
</template>

<script>
	import { mapState, mapGetters } from 'vuex'

	import { isTopTour360, isTopSlideshow } from '@/helpers/settings'

	import brandingMixin from '@/mixins/branding'
	import gaMixin from '@/mixins/ga'

	export default {
		mixins: [brandingMixin, gaMixin],
		props: {
			className: {
				default: 'list',
				type: String
			}
		},
		data () {
			return {
				menu: [
					{ to: 'video', name: 'Video' },
					{ to: 'details', name: 'Details' },
					{ to: 'gallery', name: 'Gallery' },
					{ to: 'tour360', name: '360 tour' },
					{ to: 'slideshow', name: 'Slideshow' },
					{ to: 'videoSlideshow', name: 'Video Slideshow' },
					{ to: 'floorplan', name: 'Floorplan' },
					{ to: 'documents', name: 'Documents' },
					{ to: 'walkScore', name: 'Walk Score' },
					{ to: 'map', name: 'Map' },
					{ to: 'contact', name: 'Contact' }
				]
			}
		},
		computed: {
			...mapState('tours', ['settings']),
			...mapState('utils', ['widgets']),
			...mapGetters('tours', ['getLayoutType']),
			filteredMenu () {
				const menu = Object.assign([], this.menu)

				if (isTopTour360(this.settings) && this.getLayoutType === 'one') {
					menu.shift()
					menu.unshift(this.menu[3])
					menu[3] = this.menu[0]
				}

				if (isTopSlideshow(this.settings) && this.getLayoutType === 'one') {
					menu.shift()
					menu.unshift(this.menu[4])
					menu[3] = this.menu[0]
					menu[4] = this.menu[3]
				}

				return menu.filter(({to}) =>
					this.settings[to] || (to === 'contact' && this.isBranded))
			},
			isOnePage () {
				return this.getLayoutType === 'one'
			}
		},
		methods: {
			routeUrl (name) {
				const { params: { id }, query: { branded } } = this.$route

				if (branded) {
					return { name, params: { id }, query: { branded } }
				}

				return { name, params: { id } }
			},
			onScrollingStart () {
				this.$emit('scrollingStart')
			},
			onScrollingDone () {
				this.$emit('scrollingDone')
			}
		}
	}
</script>
